// Simple shared channel for requesting AI validation via the
// active VoiceAgent instance.
//
// VoiceAgent should call registerValidationHandler with a function
// that accepts a payload ({ questions, context }) and returns
// a Promise that resolves with the validation_result message.
//
// Callers (e.g., QuestionnaireForm) can use requestValidation
// to trigger that flow and await the result.

let validationHandler = null;

export function registerValidationHandler(fn) {
  validationHandler = typeof fn === "function" ? fn : null;
}

export function unregisterValidationHandler(fn) {
  if (validationHandler === fn) {
    validationHandler = null;
  }
}

export function hasValidationHandler() {
  return typeof validationHandler === "function";
}

export function requestValidation(payload) {
  if (typeof validationHandler !== "function") {
    return Promise.reject(new Error("No AI validation handler registered"));
  }
  return validationHandler(payload);
}

// Optional shared channel for sending arbitrary control objects
// (such as section_change) from the Questionnaire form through
// the active VoiceAgent's WebSocket connection.

let controlSender = null;

export function registerControlSender(fn) {
  controlSender = typeof fn === "function" ? fn : null;
}

export function unregisterControlSender(fn) {
  if (controlSender === fn) {
    controlSender = null;
  }
}

// Fire-and-forget helper; if there is no active sender, this
// becomes a no-op so the form can call it safely.
export function sendControlFromForm(obj) {
  if (typeof controlSender !== "function") return;
  controlSender(obj);
}
